import { ResourceType } from '@repo/api-gw-sdk';

export const pitrPolicySupportedResourceTypes: ResourceType[] = [
  ResourceType.AzureSqlVirtualMachine,
];
